export function githubAppInstallEnabled(
  value = import.meta.env.VITE_GITHUB_APP_INSTALL_ENABLED
): boolean {
  return value === 'true';
}
